function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = watchManReducer;

var _constants = require('../constants');

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function getWatchList(depTree) {
  var list = Object.values(depTree);
  var components = [];
  list.forEach(function (item) {
    if (typeof item === 'string') {
      components.push(item);
    } else if (Array.isArray(item)) {
      item.forEach(function (component) {
        if (typeof component === 'string') {
          components.push(component);
        } else {
          components.push.apply(components, _toConsumableArray(getWatchList(component)));
        }
      });
    } else if (_typeof(item) === 'object' && item !== null) {
      components.push.apply(components, _toConsumableArray(getWatchList(item)));
    }
  });
  return components.filter(function (value, index, array) {
    return array.indexOf(value) === index;
  });
}

function watchManReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  if (action.type === _constants.WATCH_COMPONENT) {
    var watchList = getWatchList(action.react);

    var newState = _extends({}, state);

    Object.keys(newState).forEach(function (key) {
      newState[key] = newState[key].filter(function (value) {
        return value !== action.component;
      });
    });
    watchList.forEach(function (item) {
      if (Array.isArray(newState[item])) {
        newState[item] = [].concat(_toConsumableArray(newState[item]), [action.component]);
      } else {
        newState[item] = [action.component];
      }
    });
    return newState;
  }

  return state;
}